module.exports = __webpack_public_path__ + "static/media/pulsidL.63636607.jpg";